require('./scss/style.scss');

import React from 'react';
import ReactDOM from 'react-dom';

import App from './containers/App';


ReactDOM.render(
  <App />,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/